import React from "react";
import { NavLink, useParams } from "react-router";
import Seo from "../components/seo";
import Layout from "../components/layout";
import SectionNav from "../components/newComponents/sectionNav";
import SectionHead from "../components/newComponents/sectionHead";
import CardAlt from "../components/newComponents/cardAlt";
import Card from "../components/newComponents/card";
import { useQuery } from "@apollo/client";
import { HandleQuery, WhatWeDoAreasOfExpertiseData } from "../queries";

export function WhatWeDoAreasOfExpertiseEntry()
{
    const { slug } = useParams();

    const query_state = useQuery(WhatWeDoAreasOfExpertiseData(slug), {fetchPolicy: 'no-cache'});
    const { complete, view } = HandleQuery(query_state);
    if(!complete) return view;
    const data = query_state.data; 
        
        return(
  <Layout>
    <Seo title={data.entry[0].title} />
    <div className="main">
      <SectionNav data={data} base={`/what-we-do/${slug}`} currentUri={`/what-we-do/${slug}/areas-of-expertise`}/>
      <section className="section-overview" style={{paddingBottom: 0}}>
          <div className="shell">
          <SectionHead title={data.entry[0].title} subtitle={"Areas of Expertise"} />
            </div>
        </section>
      <section className="section-boxes-hr js-section-boxes-hr" style={{paddingTop: 0}}>
        <div className="shell">
          
          {data.entry[0].relatedAreasOfExpertiseFocusAreas.length > 0 &&
            <div className="boxes swiper-container js-load-more js-slider-boxes-projects">
              <ul>
                {data.entry[0].relatedAreasOfExpertiseFocusAreas.map((item, i) => (
                  <Card
                    key={`what-we-do-entry-area-of-expertise-focus-areas-${i}`} 
                    image={item.featureImage[0]} 
                    title={item.displayTitle} 
                    subtitle={item.summary} 
                    href={`/${item.uri}`} 
                    color={2}
                  />
                ))}
              </ul>
              <div className="swiper-pagination boxes__pagination" />
            </div>
          }
          {data.entry[0].relatedAreasOfExpertise.length > 0 &&
            <div>
              {data.entry[0].relatedAreasOfExpertise.map((item, i) => (
                <CardAlt id={`id-${item.slug}`} key={`what-we-do-areas-of-expertise-entry-${i}`} title={item.title} body={item.bodyContent} />
              ))}
            </div>
          }
          {data.entry[0].relatedAreasOfExpertiseFocusAreas.length === 0 && data.entry[0].relatedAreasOfExpertise.length === 0 &&
            <div>No content found.</div>
          }
        </div>
      </section>
    </div>
  </Layout>
);
};
